var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useCallback } from 'react';
import { withRouter } from 'react-router';
import { Container, Button } from '@material-ui/core';
import { useMutation } from '@apollo/client';
import mutationVariables from '../../utility/mutationVariables';
import { CreateDatasourceDocument } from '../../generated/graphql';
import { Credential } from '../../entities';
import StyledSelect from '../components/StyledSelect';
import FileDrop from '../components/FileDrop';
import { commands } from '../../operations/commands';
var DatasourcesNew = function (_a) {
    var history = _a.history;
    // using rest API
    var _b = useMutation(commands.CREATE_CREDENTIAL), createCredential = _b[0], _c = _b[1], credentialData = _c.data, error = _c.error;
    var _d = useMutation(CreateDatasourceDocument), createDatasource = _d[0], _e = _d[1], datasourceData = _e.data, loading = _e.loading;
    var _f = useState(), credentialFile = _f[0], setCredentialFile = _f[1];
    useEffect(function () {
        if (credentialData)
            setCredentialFile(Credential.fromJSON(credentialData.createCredential.data));
    }, [credentialData, datasourceData]);
    var onDrop = useCallback(function (acceptedFiles) { return __awaiter(void 0, void 0, void 0, function () {
        var file;
        return __generator(this, function (_a) {
            file = acceptedFiles[0];
            createCredential({ variables: { input: file } });
            return [2 /*return*/];
        });
    }); }, []);
    var _g = useState(null), selectedDataset = _g[0], setDataset = _g[1];
    var selectDatasetHandler = useCallback(function (selected) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setDataset(selected);
            return [2 /*return*/];
        });
    }); }, []);
    var submitHandler = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!credentialFile || !selectedDataset) {
                return [2 /*return*/];
            }
            createDatasource(mutationVariables({
                name: selectedDataset === null || selectedDataset === void 0 ? void 0 : selectedDataset.label,
                credential_id: credentialFile === null || credentialFile === void 0 ? void 0 : credentialFile.id,
                dataset_id: selectedDataset === null || selectedDataset === void 0 ? void 0 : selectedDataset.value,
            }));
            history.push('/datasources');
            return [2 /*return*/];
        });
    }); }, [history, credentialFile, selectedDataset]);
    return (React.createElement(Container, null,
        React.createElement("h2", null, "Connect a BigQuery Data Source"),
        credentialFile ? (React.createElement("div", null,
            credentialFile.datasets ? (React.createElement("div", null,
                React.createElement(StyledSelect, { value: selectedDataset, onChange: selectDatasetHandler, options: credentialFile.datasets.map(function (v /* dataset type? */) { return ({
                        value: v.id,
                        label: v.id,
                    }); }) }))) : null,
            React.createElement(Button, { variant: "contained", color: "primary", disabled: !selectedDataset, onClick: submitHandler }, "Submit"))) : (React.createElement(FileDrop, { onDrop: onDrop }))));
};
export default withRouter(DatasourcesNew);
